import { Input } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useMissingCompanyDetailsForm } from '../../../../../../contexts/missingCompanyDetailsFormContext'

export const CompanyStreetAddress2 = (): ReactElement => {
  const { t } = useTranslation()
  const {
    missingCompanyDetailsForm: { FormItem },
  } = useMissingCompanyDetailsForm()

  return (
    <FormItem
      label={t('external_invoices.missing_company_compliance_details.modal.form.field.address.street_address_2.label')}
      name="addressLine2"
      render={({ field }) => {
        return <Input {...field} size="sm" />
      }}
    />
  )
}
